import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SiteContentProvider } from "./context/SiteContentContext";
import { Navbar } from "./components/Navbar";
import { EmergencyBanner } from "./components/EmergencyBanner";
import { Footer } from "./components/Footer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import ServicesPage from "./pages/ServicesPage";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Booking from "./pages/Booking";
import OnlineConsultation from "./pages/OnlineConsultation";
import PatientDashboard from "./pages/PatientDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import RecoverAccount from "./pages/RecoverAccount";
import RecoveryRequestsPage from "./pages/RecoveryRequestsPage";
import ForgotPassword from "./pages/ForgotPassword";
import ProfessionalRegister from "./pages/ProfessionalRegister";
import ProfessionalLogin from "./pages/ProfessionalLogin";
import ProfessionalDashboard from "./pages/ProfessionalDashboard";
import AdminProfessionalsPage from "./pages/AdminProfessionalsPage";
import BookWithProfessional from "./pages/BookWithProfessional";
import CareProviders from "./pages/CareProviders";
import AdminReferralsPage from "./pages/AdminReferralsPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <AuthProvider>
        <SiteContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <EmergencyBanner />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/recover-account" element={<RecoverAccount />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/professional/register" element={<ProfessionalRegister />} />
              <Route path="/professional/login" element={<ProfessionalLogin />} />
              <Route path="/book-with-professional" element={<BookWithProfessional />} />
              <Route path="/care-providers" element={<CareProviders />} />
              <Route
                path="/professional/dashboard/*"
                element={
                  <ProtectedRoute>
                    <ProfessionalDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/booking"
                element={
                  <ProtectedRoute>
                    <Booking />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/online-consultation"
                element={
                  <ProtectedRoute>
                    <OnlineConsultation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <PatientDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/recovery-requests"
                element={
                  <ProtectedRoute adminOnly>
                    <RecoveryRequestsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/professionals"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminProfessionalsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/referrals"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminReferralsPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        </SiteContentProvider>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
